import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { FavoriteToggle } from '../../../common/react/components/FavoriteToggle/FavoriteToggle';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { DataRoleTooltip } from '../Tooltips/DataRoleTooltip';
import { TooltipAnchor } from '../Tooltips/TooltipAnchor';
import { CardViewStyles, THUMBNAIL_HEIGHT, TOTAL_CARD_WIDTH } from './CardViewStyles';
import { ContentCard, getContentUrlForItem } from './ContentCard';
import { DataRoleThumbnail } from './DataRoleThumbnail';
import { DetailsTooltipStyles } from './DetailsTooltipStyles';
import { Thumbnail } from './Thumbnail';

export class DataRoleCard extends ContentCard {

  public render() {
    return (
      <div className={CardViewStyles.Card}>
      <TooltipAnchor tooltipContent ={this.renderTooltipContent}width={DetailsTooltipStyles.Width} onShowTooltip={this.handleShowTooltip} delay={0}
      title={Messages.dataRoleTooltipTitle()}>
         <DataRoleThumbnail
              hoveredOrSelected={this.props.hoveredOrSelected}
              navigateUrl={getContentUrlForItem(this.props.content, this.props.urls)}
              owner={this.props.content.owner}
              urls={this.props.urls}
            />
      </TooltipAnchor>
        <div className={CardViewStyles.ActionRow}>
          <span className={CardViewStyles.ActionRowName} title={this.props.content.name}>
            { this.props.content.name }
          </span>
          <span>
            <FavoriteToggle
              canHaveKeyboardFocus={true}
              isFavorite={this.props.content.favorite}
              onAddFavorite={() => this.props.addContentFavorite(this.props.content.id, 'dataRole')}
              onRemoveFavorite={() => this.props.removeContentFavorite(this.props.content.id, this.props.content.id, 'dataRole', this.props.content.name)}
            />
          </span>
          { this.renderActionsMenu() }
        </div>
      </div>
    );
  }

  private renderTooltipContent = () => {
    return <DataRoleTooltip content={this.props.content}
                        urls={this.props.urls} />;
  }
}
